"use client";

import { useEffect } from "react";
import { zustandStore } from "@/app/zustand-store";

const DataSyncErrorHandler = () => {
  const { data, actions } = zustandStore();

  useEffect(() => {
    // Reset error status if there's already processed data and status is failed
    // if (data.processedData && data.processingStatus.status === "failed") {
    //   actions.updateProcessingStatus({
    //     ...data.processingStatus,
    //     status: "completed",
    //     error: undefined,
    //   });
    // }

    // Set a timeout to check for errors after 15 seconds
    const timeoutId = setTimeout(async () => {
      const checkForErrors = async () => {
        try {
          // Don't run error checks if processing is currently in progress
          if (data.processingStatus?.status === "processing") {
            return;
          }

          // COMMENTED OUT: Check for DATA_SYNC_ERROR notifications
          // const notificationsResponse = await axios.get("/api/notifications");
          // const notifications = notificationsResponse.data.notifications || [];
          //
          // const errorNotification = notifications.find(
          //   (notification: any) =>
          //     notification.type === "DATA_SYNC_ERROR" && !notification.isRead,
          // );
          //
          // if (errorNotification) {
          //   actions.updateProcessingStatus({
          //     ...data.processingStatus,
          //     status: "failed",
          //     error: "A data sync error occurred. Please retry.",
          //     notificationId: errorNotification._id,
          //     mailchimpKeyId: errorNotification.mailchimpKeyId,
          //   });
          //   return;
          // }

          // Check for null processedData fields
          const processedData = data.processedData;
          if (processedData) {
            const requiredFields: (keyof typeof processedData)[] = [
              "allEmails",
              "automationData",
              "campaignsData",
              // "deliverabilityMetrics",
              // "ecommerceData",
              // "revenueData",
              "subscribersData",
            ];

            const hasNullField = requiredFields.some(
              (field) => processedData[field] === null,
            );

            if (hasNullField) {
              // Update the Zustand store with error status
              // Preserve existing mailchimpKeyId to ensure retry button works
              // Update the Zustand store with error status
              // Preserve existing mailchimpKeyId to ensure retry button works
              // actions.updateProcessingStatus({
              //   ...data.processingStatus,
              //   status: "failed",
              //   error: "Incomplete data detected.",
              // });

              // Instead of showing error in processing bar, open the no-data modal
              // This is cleaner UI for empty accounts
              actions.updateProcessingStatus({
                status: "idle",
                progress: 0,
                currentStep: "",
                error: undefined,
              });

              actions.openModal({
                modalName: "mailchimp-api-key",
                modalProps: { reason: "no-data" }
              });
            } else {
              // All required fields are present, hide the popup if it's in failed state
              if (data.processingStatus?.status === "failed") {
                actions.updateProcessingStatus({
                  status: "idle",
                  progress: 0,
                  currentStep: "",
                  error: undefined,
                });
              }
            }
          }
        } catch (error) {
          console.error("Error in DataSyncErrorHandler:", error);
        }
      };

      checkForErrors();
    }, 15000); // 15 seconds delay

    // Clean up the timeout when component unmounts
    return () => clearTimeout(timeoutId);
  }, [data.processedData, data.processingStatus?.status, actions]);

  // This component doesn't render anything visible
  return null;
};

export default DataSyncErrorHandler;
